import { View, StyleSheet } from "react-native";
import ChatBarContainer from "../containers/navigation/ChatBarContainer/ChatBarContainer";
import MobileHeaderContainer from "../containers/navigation/MobileHeaderContainer/MobileHeaderContainer";
import CustomSpacing from "../components/common/layout/CustomSpacing/CustomSpacing";
import { ScrollView } from "react-native-gesture-handler";
import { MotiView } from "moti";
import { useAppState } from "../contexts/AppStateContext";
import { useAppConfig } from "../AppConfigProvider";
import { useChatBar } from "../contexts/ChatBarContext";
import TopMenuContainer from "../containers/navigation/TopMenuContainer/TopMenuContainer";
import MainMenuContainer from "../containers/navigation/MainMenuContainer/MainMenuContainer";
import CustomCourseworkMenuContainer from "../containers/navigation/CustomCourseworkMenuContainer.js/CustomCourseworkMenuContainer";
import ChatWindowContainer from "../containers/chatWindow/ChatWindowContainer/ChatWindowContainer";
import CourseHeaderContainer from "../containers/customCoursework/CourseHeaderContainer";

const MobileDefaultLayout = ({ children, menuType, courseName, pageHasChat, showCourseNav }) => {
  const { state } = useAppState();
  const appConfig = useAppConfig();
  const isAxioOffering = appConfig.isAxioOffering;
  const { showChat } = useChatBar();

  const showCustomCourseworkMenu = menuType === "customCoursework";

  const isMenuActive = state.meta.isMainMenuExpanded || state.meta.isCustomCourseworkMenuOpen;

  return (
    <View style={styles.smallContainer} aria-hidden={showChat}>
      {showCourseNav ? (
        <CourseHeaderContainer />
      ) : (
        <MobileHeaderContainer isShowCustomCoursework={menuType === "customCoursework"} />
      )}
      <CustomSpacing type="vertical" size="l" />
      <View style={styles.mobileChildrenContainer} aria-live="polite" aria-hidden={isMenuActive}>
        <ScrollView style={styles.scrollView} showsVerticalScrollIndicator={true} tabIndex={0}>
          {children}
        </ScrollView>
      </View>
      <MotiView
        id="main-menu"
        style={styles.mobileMenuContainer}
        transition={{ delay: 400, damping: 15, mass: 1 }}
        from={{
          translateX: -600,
        }}
        animate={{
          translateX: state.meta.isMainMenuExpanded ? 0 : -600,
        }}
        aria-hidden={!state.meta.isMainMenuExpanded}>
        {isAxioOffering ? <TopMenuContainer /> : <MainMenuContainer />}
      </MotiView>
      {showCustomCourseworkMenu && (
        <MotiView
          id="custom-coursework-menu"
          style={styles.mobileMenuContainer}
          transition={{ delay: 400, damping: 15, mass: 1 }}
          from={{
            translateX: -600,
          }}
          animate={{
            translateX: state.meta.isCustomCourseworkMenuOpen ? 0 : -600,
          }}
          aria-hidden={!state.meta.isCustomCourseworkMenuOpen}>
          <CustomCourseworkMenuContainer />
        </MotiView>
      )}
      {pageHasChat && (
        <MotiView
          id="chat-bar"
          style={styles.chatBarContainer}
          animate={{
            scale: state.meta.isExpanded ? 1 : 1,
            opacity: state.meta.isExpanded ? 1 : 1,
          }}
          // @ts-expect-error - transition is not typed
          transition={{ type: "timing", duration: 650 }}
          aria-hidden={isMenuActive}>
          <ChatBarContainer />
        </MotiView>
      )}
      {showChat && <ChatWindowContainer />}
    </View>
  );
};

const styles = StyleSheet.create({
  smallContainer: {
    flex: 1,
    backgroundColor: "#ffffff",
  },
  mobileChildrenContainer: {
    flex: 1,
    paddingHorizontal: 20,
  },
  chatBarContainer: {
    width: "100%",
    maxWidth: 1400,
    alignSelf: "center",
    zIndex: 999,
  },
  mobileMenuContainer: {
    zIndex: 9999,
    position: "absolute",
    bottom: 0,
    top: 85,
    right: 0,
    left: 0,
  },
  scrollView: {
    height: 20,
  },
});

export default MobileDefaultLayout;
